export const article2Questions = [
  {
    id: 1,
    koreanQuestion:
      "그러나, 회사는 강조했다 그... 많은 필수 품목들이 유지될 것이라고 현재 가격에, 그리고 계절 할인이 계속될 것이라고 계획대로",
    question:
      "However, the company emphasized that many essential items will remain ______ current prices, and seasonal discounts will continue as planned.",
    choices: {
      A: "at",
      B: "for",
      C: "on",
      D: "by",
    },
    correctAnswer: "A",
    explanation:
      "(A) at: '~에', 가격을 나타낼 때 사용하는 적절한 전치사입니다. 'remain at current prices'는 '현재 가격을 유지하다'라는 의미로 정확합니다.\n\n(B) for: '~을 위해', 가격 표현에 적합하지 않습니다.\n\n(C) on: '~위에', 특정 가격에 머무른다는 표현에는 부적절합니다.\n\n(D) by: '~에 의해', 가격 표현과 함께 사용하기에 적합하지 않습니다.",
    translation:
      "그러나, 회사는 많은 필수 품목들이 현재 가격에 유지될 것이며, 계절 할인이 계획대로 계속될 것이라고 강조했다.",
    type: "article",
  },
  {
    id: 2,
    koreanQuestion:
      "일부 조정이 필요하기 때문에, 우리는 (현재) 일하고 있다 열심히 최소화 하기 위해 영향을 우리 고객에게",
    question:
      "______ some adjustments are necessary, we are working hard to minimize the impact on our customers.",
    choices: {
      A: "Because",
      B: "Although",
      C: "While",
      D: "Unless",
    },
    correctAnswer: "C",
    explanation:
      "(A) Because: '~때문에'라는 의미로, 인과관계를 나타내는 접속사입니다. 문맥상 대조의 의미가 필요하므로 부적절합니다.\n\n(B) Although: '비록 ~일지라도'라는 의미로 대조를 나타내지만, 'While'이 더 자연스러운 선택입니다.\n\n(C) While: '~하는 동안'이라는 의미 외에도 '~이긴 하지만'이라는 양보의 의미로 사용되어 두 절 사이의 대조를 나타냅니다. 이 문맥에서 가장 적절합니다.\n\n(D) Unless: '~하지 않는 한'이라는 조건을 나타내는 접속사로, 문맥에 맞지 않습니다.",
    translation:
      "일부 조정이 필요하긴 하지만, 우리는 고객에게 미치는 영향을 최소화하기 위해 열심히 노력하고 있습니다.",
    type: "article",
  },
  {
    id: 3,
    koreanQuestion:
      "심각한 홍수에도 불구하고 4월에, 시의회는 수리했다 모든 손상된 다리들을 ____ 2주 안에.",
    question:
      "Despite severe flooding in April, the city council repaired all damaged bridges ____ two weeks.",
    choices: {
      A: "during",
      B: "within",
      C: "over",
      D: "between",
    },
    correctAnswer: "B",
    explanation:
      "(B) within: '~이내에'라는 의미로, 특정 기간 안에 완료된 행동을 표현할 때 가장 적절합니다.\n\n(A) during: '~동안에'라는 의미로, 특정 기간 내내 지속된 행동을 표현할 때 사용되며 이 문맥에서는 덜 정확합니다.\n\n(C) over: '~에 걸쳐서'라는 의미로, 기간 전체에 걸쳐 진행된 행동을 표현하는 데 사용되며 이 문맥에서는 적절하지 않습니다.\n\n(D) between: '~사이에'라는 의미로, 두 시점 사이의 관계를 나타내는 데 사용되며 이 문맥에서는 적절하지 않습니다.",
    translation:
      "4월의 심각한 홍수에도 불구하고, 시의회는 모든 손상된 다리들을 2주 이내에 수리했다.",
    type: "article",
  },
  {
    id: 4,
    koreanQuestion:
      "분기별 수익 보고서는 포함했다 ______ 분석을, 안심시키는 투자자들을 회사의 건전성에 대해.",
    question:
      "The quarterly earnings report contained a ______ analysis, reassuring investors of the company's health.",
    choices: {
      A: "concise",
      B: "ambiguous",
      C: "disappointing",
      D: "dormant",
    },
    correctAnswer: "A",
    explanation:
      "(A) concise: '간결한, 간명한'이라는 의미로, 투자자들을 안심시키는 명확하고 간결한 분석을 의미합니다.\n\n(B) ambiguous: '모호한, 불분명한'이라는 의미로, 투자자들을 안심시키기 위한 보고서의 특성으로는 적절하지 않습니다.\n\n(C) disappointing: '실망스러운'이라는 의미로, 투자자들을 안심시키는 분석과는 반대되는 의미입니다.\n\n(D) dormant: '휴면 상태의, 활동하지 않는'이라는 의미로, 분석을 설명하는 데 적절하지 않습니다.",
    translation:
      "분기별 수익 보고서는 간결한 분석을 포함했으며, 이는 투자자들에게 회사의 건전성에 대해 안심을 주었다.",
    type: "article",
  },
  {
    id: 5,
    koreanQuestion:
      "시장은 전달했다 ______ 연설을 경제 발전에 관한, 광범위한 찬사를 받으며.",
    question:
      "The mayor delivered a ______ speech about economic development, drawing widespread praise.",
    choices: {
      A: "monotonous",
      B: "mediocre",
      C: "compelling",
      D: "captive",
    },
    correctAnswer: "C",
    explanation:
      "(C) compelling: '설득력 있는, 강력한 인상을 주는'이라는 의미로, 광범위한 찬사를 받은 연설을 묘사하는 데 가장 적절합니다.\n\n(A) monotonous: '단조로운, 지루한'이라는 의미로, 찬사를 받은 연설과는 맞지 않습니다.\n\n(B) mediocre: '평범한, 보통의'라는 의미로, 광범위한 찬사를 받은 연설을 묘사하기에 적절하지 않습니다.\n\n(D) captive: '포로가 된, 사로잡힌'이라는 의미로, 연설을 묘사하는 데 적절하지 않습니다.",
    translation:
      "시장은 경제 발전에 관한 설득력 있는 연설을 전달했으며, 이는 광범위한 찬사를 받았다.",
    type: "article",
  },
  {
    id: 6,
    koreanQuestion:
      "마지막 시즌은 드라마 시리즈 가졌다 ____ 피날레 그... 만족시켰던 오랜 팬들을.",
    question:
      "The final season of the drama series had a ______ finale that satisfied long-time fans.",
    choices: {
      A: "anticlimactic",
      B: "predictable",
      C: "spectacular",
      D: "secular",
    },
    correctAnswer: "C",
    explanation:
      "(C) spectacular: '장관을 이루는, 화려한'이라는 의미로, 오랜 팬들을 만족시킨 피날레를 묘사하는 데 가장 적절합니다.\n\n(A) anticlimactic: '김빠진, 실망스러운'이라는 의미로, 팬들을 만족시킨 피날레와는 맞지 않습니다.\n\n(B) predictable: '예측 가능한'이라는 의미로, 일반적으로 긍정적인 평가가 아니므로 팬들을 만족시킨 피날레를 묘사하기에 적절하지 않습니다.\n\n(D) secular: '세속적인, 종교적이지 않은'이라는 의미로, 드라마 피날레를 묘사하는 데 적절하지 않습니다.",
    translation:
      "드라마 시리즈의 마지막 시즌은 장관을 이루는 피날레로 오랜 팬들을 만족시켰다.",
    type: "article",
  },
  {
    id: 7,
    koreanQuestion:
      "자선 갈라 행사는 선보였다 ______ 공연을 그... 사로잡았던 모든 참석자들을.",
    question:
      "The charity gala featured a ______ performance that captivated all attendees.",
    choices: {
      A: "lackluster",
      B: "stunning",
      C: "sporadic",
      D: "superficial",
    },
    correctAnswer: "B",
    explanation:
      "(B) stunning: '멋진, 놀라운'이라는 의미로, 모든 참석자들을 사로잡은 공연을 묘사하는 데 가장 적절합니다.\n\n(A) lackluster: '활기가 없는, 지루한'이라는 의미로, 모든 참석자들을 사로잡은 공연과는 맞지 않습니다.\n\n(C) sporadic: '간헐적인, 산발적인'이라는 의미로, 공연을 묘사하는 데 적절하지 않습니다.\n\n(D) superficial: '피상적인, 표면적인'이라는 의미로, 감동적인 공연을 묘사하는 데 적절하지 않습니다.",
    translation:
      "자선 갈라 행사는 모든 참석자들을 사로잡은 멋진 공연을 선보였다.",
    type: "article",
  },
  {
    id: 8,
    koreanQuestion:
      "ATT Technologies Inc는 (현재)결정했다 중단하기로 ______ 개인용 컴퓨터를 집중하기 위해 모바일 통신 시장에.",
    question:
      "ATT Technologies Inc has decided to discontinue ______ personal computers in order to concentrate on the mobile communications market.",
    choices: {
      A: "produce",
      B: "producing",
      C: "product",
      D: "to produce",
    },
    correctAnswer: "B",
    explanation:
      "(B) producing: 'discontinue'(중단하다) 동사 뒤에는 동명사(-ing)가 와야 합니다. 'discontinue producing'은 '생산을 중단하다'라는 의미입니다.\n\n(A) produce: 동사 원형으로, 'discontinue' 뒤에 바로 사용할 수 없습니다.\n\n(C) product: '제품'이라는 의미의 명사로, 여기서는 문법적으로 맞지 않습니다.\n\n(D) to produce: 부정사 형태로, 'discontinue' 뒤에는 일반적으로 사용되지 않습니다.",
    translation:
      "ATT Technologies Inc는 모바일 통신 시장에 집중하기 위해 개인용 컴퓨터 생산을 중단하기로 결정했습니다.",
    type: "article",
  },
  {
    id: 9,
    koreanQuestion:
      "_____ 중요한 면접을, 후보자는 찾아야 합니다 다른 기회를 얻기 위해 새로운 일자리를.",
    question:
      "______ the important interview, the candidate has to find another opportunity to get a new job.",
    choices: {
      A: "have missed",
      B: "missed",
      C: "to miss",
      D: "missing",
    },
    correctAnswer: "D",
    explanation:
      "(D) missing: 현재분사로 문장을 시작하여 '~을 놓친 후에'라는 의미를 나타냅니다. 'Missing the important interview'는 '중요한 면접을 놓친 후에'라는 의미로, 이 상황 이후에 후보자가 새로운 기회를 찾아야 한다는 내용을 자연스럽게 연결합니다.\n\n(A) have missed: 현재완료 시제로, 문장 시작 부분에 단독으로 사용할 수 없습니다.\n\n(B) missed: 과거형 동사로, 문장 시작 부분에 단독으로 사용하기에 적절하지 않습니다.\n\n(C) to miss: 부정사 형태로, 이 문맥에서 문법적으로 맞지 않습니다.",
    translation:
      "중요한 면접을 놓친 후, 후보자는 새로운 일자리를 얻기 위한 다른 기회를 찾아야 합니다.",
    type: "article",
  },
  {
    id: 10,
    koreanQuestion:
      "______ 4년도 채 안된, 자이언트 기업은 (현재)되었다 하나가 선도적인 자동차 제조업체 중 유럽에서 .",
    question:
      "______ less than 4 years ago, the Giant corporation has become one of the leading car manufacturers in Europe.",
    choices: {
      A: "Established",
      B: "Establishing",
      C: "To establish",
      D: "Having established",
    },
    correctAnswer: "A",
    explanation:
      "과거분사(Established)가 문장의 시작에 사용되어 '설립된 이후'라는 의미를 나타냅니다. 'Established less than 4 years ago'는 '4년도 채 안 된 시간 전에 설립된'이라는 의미로, 자이언트 기업이 설립된 시점을 나타냅니다.",
    translation:
      "4년도 채 안 된 시간 전에 설립되어, 자이언트 기업은 유럽에서 선도적인 자동차 제조업체 중 하나가 되었습니다.",
    type: "article",
  },
  {
    id: 11,
    koreanQuestion:
      "많은 학생들은 의대로부터 되고 싶어합니다 의사가 그... 연간 수입이 더 높은 간호사보다.",
    question:
      "Many students from medical schools want to be a doctor ______ annual income is higher than that of a nurse.",
    choices: {
      A: "which",
      B: "whom",
      C: "whose",
      D: "who",
    },
    correctAnswer: "C",
    explanation:
      "(C) whose: 소유격 관계대명사 'whose'는 '~의'라는 의미로, 사람이나 사물의 소유관계를 나타냅니다. 여기서는 '의사의 연간 수입'을 의미하므로 'whose'가 정답입니다.\n\n(A) which: 주격 또는 목적격 관계대명사로 사물을 지칭할 때 사용하며, 소유관계를 나타내지 않습니다.\n\n(B) whom: 목적격 관계대명사로 사람을 지칭할 때 사용하며, 소유관계를 나타내지 않습니다.\n\n(D) who: 주격 관계대명사로 사람을 지칭할 때 사용하며, 소유관계를 나타내지 않습니다.",
    translation:
      "많은 의과대학 학생들은 연간 수입이 간호사보다 높은 의사가 되고 싶어합니다.",
    type: "article",
  },
  {
    id: 12,
    koreanQuestion:
      "수천 개의 고객 주문이 _____ 배송 센터에서 오늘 보장하기 위해 익일 배송을.",
    question:
      "Thousands of customer orders _____ at the distribution center today to ensure next-day delivery.",
    choices: {
      A: "are processed",
      B: "have been processed",
      C: "will be processed",
      D: "are being processed",
    },
    correctAnswer: "D",
    explanation:
      "(D) are being processed: '처리되고 있다'라는 의미의 현재진행형 수동태로, 현재 진행 중인 행동을 나타내기에 가장 적절합니다.\n\n(A) are processed: '처리된다'라는 의미의 단순현재 수동태로, 일반적인 사실이나 반복적인 행동을 나타내지만 현재 진행 중인 특정 상황을 설명하기에는 적절하지 않습니다.\n\n(B) have been processed: '처리되어 왔다'라는 의미의 현재완료 수동태로, 과거에 시작되어 현재까지 영향을 미치는 완료된 행동을 나타내지만, 현재 진행 중인 처리 과정을 설명하기에는 적절하지 않습니다.\n\n(C) will be processed: '처리될 것이다'라는 의미의 미래 수동태로, 아직 시작되지 않은 미래의 행동을 나타내므로 현재 진행 중인 상황을 설명하기에 적절하지 않습니다.",
    translation:
      "수천 개의 고객 주문이 익일 배송을 보장하기 위해 오늘 배송 센터에서 처리되고 있습니다.",
    type: "article",
  },
  {
    id: 13,
    koreanQuestion:
      "보건부에 따르면, 500,000개의 백신 접종분이 ____ 지역 배포 센터에서 이번 주에 가속화하기 위해 예방접종 캠페인을.",
    question:
      "According to the Ministry of Health, 500,000 vaccine doses ______ at regional distribution centers this week to accelerate the immunization campaign.",
    choices: {
      A: "have been distributing",
      B: "are distributed",
      C: "were distributing",
      D: "are being distributed",
    },
    correctAnswer: "D",
    explanation:
      "(D) are being distributed: '배포되고 있다'라는 의미의 현재진행형 수동태로, 현재 진행 중인 행동을 나타내기에 가장 적절합니다.\n\n(A) have been distributing: '배포해 왔다'라는 의미의 현재완료 능동태로, 수동의 의미가 필요한 이 문맥에서는 적절하지 않습니다.\n\n(B) are distributed: '배포된다'라는 의미의 단순현재 수동태로, 일반적인 사실이나 반복적인 행동을 나타내지만 현재 진행 중인 특정 상황을 설명하기에는 적절하지 않습니다.\n\n(C) were distributing: '배포하고 있었다'라는 의미의 과거진행형 능동태로, 과거의 진행 중인 행동을 나타내며 현재 상황과 수동의 의미를 표현하기에 적절하지 않습니다.",
    translation:
      "보건부에 따르면, 예방접종 캠페인을 가속화하기 위해 500,000개의 백신 접종분이 이번 주에 지역 배포 센터에서 배포되고 있습니다.",
    type: "article",
  },
  {
    id: 14,
    koreanQuestion:
      "재택근무는 할 수 있게 한다 기업들이 유지하도록 숙련된 근로자들이 그.. 집이 멀리 떨어져 있는 회사로부터 일할 수 있도록 집에서.",
    question:
      "Telecommuting enables companies to keep skilled workers ______ homes are away from the companies to work at home.",
    choices: {
      A: "whose",
      B: "who",
      C: "whom",
      D: "where",
    },
    correctAnswer: "A",
    explanation:
      "소유격 관계대명사 'whose'는 '~의'라는 의미로, 사람이나 사물의 소유관계를 나타냅니다. 여기서는 '근로자들의 집'을 의미하므로 'whose'가 정답입니다.",
    translation:
      "재택근무는 집이 회사에서 멀리 떨어져 있는 숙련된 근로자들이 집에서 일할 수 있도록 기업들이 그들을 유지할 수 있게 해줍니다.",
    type: "article",
  },
  {
    id: 15,
    koreanQuestion:
      "비율은 광고 지출 텔레비전 광고에  ______ 43% 이다 2012년에 그리고 이 비율은 증가했다 약간만 45%로 2017년에.",
    question:
      "The percentage of advertising spending on television advertising ______ 43% in 2012 and this increased only marginally to 45% in 2017.",
    choices: {
      A: "was",
      B: "were",
      C: "is",
      D: "are",
    },
    correctAnswer: "A",
    explanation:
      "과거 시점(2012년)에 대한 서술이므로 과거 시제가 필요합니다. 비율은 43% 였다",
    translation:
      "텔레비전 광고에 대한 광고 지출 비율은 2012년에 43%였고 이는 2017년에 45%로 약간만 증가했습니다.",
    type: "article",
  },
  {
    id: 16,
    koreanQuestion:
      "미국 실업률은 ______ 7.9%로 9월 2020년에 8.4%로부터 이전 달에.",
    question:
      "The US unemployment rate ______ to 7.9 percent in September 2020 from 8.4 percent in the previous month.",
    choices: {
      A: "declined",
      B: "declining",
      C: "decline",
      D: "will decline",
    },
    correctAnswer: "A",
    explanation:
      "(A) declined: '감소했다'라는 의미의 과거 시제 동사로, 과거에 일어난 사건을 설명할 때 적절합니다. 문맥상 실업률이 8.4%에서 7.9%로 감소했으므로 'declined'가 정답입니다.\n\n(B) declining: '감소하는'이라는 의미의 현재분사로, 동사의 역할을 할 수 없어 문법적으로 적절하지 않습니다.\n\n(C) decline: '감소하다'라는 의미의 동사 원형으로, 3인칭 단수 주어와 함께 사용할 때는 's'가 필요하며 과거 시제를 나타내지 못합니다.\n\n(D) will decline: '감소할 것이다'라는 의미의 미래 시제로, 이미 일어난 과거의 사건을 설명하는 데 적절하지 않습니다.",
    translation:
      "미국 실업률은 2020년 9월에 이전 달 8.4%에서 7.9%로 감소했습니다.",
    type: "article",
  },
  {
    id: 17,
    koreanQuestion: "해리는 ______ 책임자로 영업부서 5년전에 오늘로부터.",
    question:
      "Harry ______ to the head of the sales department five years ago today.",
    choices: {
      A: "was promoted",
      B: "promoted",
      C: "will be promoted",
      D: "has promoted",
    },
    correctAnswer: "A",
    explanation:
      "(A) was promoted: '승진되었다'라는 의미로, 과거에 일어난 일을 나타내는 과거 시제 수동태입니다. 5년 전에 일어난 일이므로 과거 시제가 적절합니다.\n\n(B) promoted: 과거분사만 사용되어 문법적으로 불완전합니다.\n\n(C) will be promoted: '승진될 것이다'라는 의미의 미래 시제로, 과거에 일어난 일을 설명하는 데 적절하지 않습니다.\n\n(D) has promoted: '승진시켰다'라는 의미의 현재완료 능동태로, 해리가 승진의 주체가 아닌 대상이므로 적절하지 않습니다.",
    translation:
      "해리는 오늘로부터 5년 전에 영업부서의 책임자로 승진되었습니다.",
    type: "article",
  },
  {
    id: 18,
    koreanQuestion:
      "그 기업의 포트폴리오는 고객들 구성되어 있습니다 고객들로 13개 미국 주들로부터  ______ 25개국들의.",
    question:
      "The corporation's portfolio of clients consists of customers from 13 American states ______ 25 countries.",
    choices: {
      A: "nor",
      B: "and",
      C: "by",
      D: "both",
    },
    correctAnswer: "B",
    explanation:
      "A: '~도 아니다'라는 부정의 의미를 가진 접속사로, 'neither...nor' 구조에서 사용됩니다. B: '그리고'라는 의미의 접속사로, 두 개 이상의 항목을 연결할 때 사용됩니다. C: '~에 의해'라는 의미의 전치사로, 이 문맥에서는 적절하지 않습니다. D: '둘 다'라는 의미의 형용사로, 'both...and' 구조에서 사용되지만 단독으로는 적절하지 않습니다.",
    translation:
      "그 기업의 고객 포트폴리오는 13개 미국 주와 25개국의 고객들로 구성되어 있습니다.",
    type: "article",
  },
  {
    id: 19,
    koreanQuestion:
      "최근 조사는 ___ 그.. 건물이 구조적으로 부실할 수 있다는것을 사용으로 인해 저품질 자재들을 건설 동안에.",
    question:
      "The recent investigation ______ that the building may be structurally unsound due to the use of substandard materials during construction.",
    choices: {
      A: "reveals",
      B: "is revealed",
      C: "was revealed",
      D: "has revealed",
    },
    correctAnswer: "D",
    explanation:
      "(A) reveals: '밝히다'라는 의미의 현재 시제 동사로, 조사가 현재 무언가를 밝히고 있다는 의미입니다. 이 문맥에서는 조사가 이미 완료되어 결과를 밝혀낸 상황이므로 적절하지 않습니다.\n\n(B) is revealed: '밝혀지다'라는 의미의 현재 시제 수동태로, 조사 자체가 밝혀지는 것이 아니라 조사가 무언가를 밝혀내는 것이므로 적절하지 않습니다.\n\n(C) was revealed: '밝혀졌다'라는 의미의 과거 시제 수동태로, 조사가 과거에 밝혀진 것이 아니라 조사가 무언가를 밝혀낸 것이므로 적절하지 않습니다.\n\n(D) has revealed: '밝혀냈다'라는 의미의 현재완료 시제로, 최근에 완료된 조사가 결과를 밝혀냈다는 의미를 정확히 전달합니다. 현재와 관련이 있는 과거의 행동을 나타내는 현재완료 시제가 가장 적절합니다.",
    translation:
      "최근 조사는 건설 중 저품질 자재 사용으로 인해 건물이 구조적으로 불안정할 수 있다는 것을 밝혀냈습니다.",
    type: "article",
  },
  {
    id: 20,
    koreanQuestion:
      "그는 또한 덧붙입니다 그.. 향후 몇 년 동안 회사가 생산할 수 있을 것이다 재생 에너지를, 그.. (미래에) 도울 억제하도록 지구 온난화를 장기적으로.",
    question:
      "He also adds that in the coming years the company will be able to produce renewable energy, _____ will help to curb global warming in the long run.",
    choices: {
      A: "which",
      B: "that",
      C: "where",
      D: "what",
    },
    correctAnswer: "A",
    explanation:
      "A: '관계대명사 which'는 선행사(재생 에너지)를 수식하는 비제한적 관계절을 이끌 때 사용됩니다. B: '관계대명사 that'은 제한적 관계절에서 사용되며, 콤마 뒤에 오는 비제한적 관계절에는 적합하지 않습니다. C: '관계부사 where'는 장소를 나타내는 선행사를 수식할 때 사용됩니다. D: '관계대명사 what'은 선행사가 없을 때 사용됩니다.",
    translation:
      "그는 또한 향후 몇 년 동안 회사가 재생 에너지를 생산할 수 있을 것이며, 이는 장기적으로 지구 온난화를 억제하는 데 도움이 될 것이라고 덧붙입니다.",
    type: "article",
  },
  {
    id: 21,
    koreanQuestion:
      "더 자세히 설명하자면, 후속 프로젝트는 인력이 충원되었습니다 2,000명 이상의 현지 캐나다 건설업자들에 의해, 그... ____ 나중에 고용되었습니다 정규직으로 정유소에 의해.",
    question:
      "To further illustrate, a subsequent project was staffed by over 2,000 local Canadian constructors, _____ were later hired full-time by the refinery.",
    choices: {
      A: "who",
      B: "whom",
      C: "which",
      D: "whose",
    },
    correctAnswer: "A",
    explanation:
      "A: '관계대명사 who'는 사람을 가리키는 선행사(constructors)를 수식하는 주격 관계대명사로, 관계절에서 주어 역할을 합니다. B: '관계대명사 whom'은 사람을 가리키는 선행사를 수식하는 목적격 관계대명사로, 이 문장에서는 관계절의 주어가 필요하므로 적절하지 않습니다. C: '관계대명사 which'는 사물을 가리키는 선행사를 수식할 때 사용되므로 사람인 'constructors'에는 적합하지 않습니다. D: '관계대명사 whose'는 소유격 관계대명사로, 이 문맥에서는 필요하지 않습니다.",
    translation:
      "더 자세히 설명하자면, 후속 프로젝트는 2,000명 이상의 현지 캐나다 건설업자들에 의해 인력이 충원되었으며, 이들은 나중에 정유소에 의해 정규직으로 고용되었습니다.",
    type: "article",
  },
  {
    id: 22,
    koreanQuestion:
      "다음 주부터, 모든 지하철역이 뉴욕시안의 일시적으로 폐쇄될 것입니다.",
    question:
      "_____ next week, all subway stations in New York City will be temporarily closed.",
    choices: {
      A: "Effective",
      B: "Efficiency",
      C: "Effectively",
      D: "Effect",
    },
    correctAnswer: "A",
    explanation:
      "(A) Effective: '~부터 유효한'이라는 의미로, 특정 시점부터 무언가가 시행됨을 나타내는 표현입니다. 'Effective next week'는 '다음 주부터 시행되는'이라는 의미로 가장 적절합니다.\n\n(B) Efficiency: '효율성'이라는 명사로, 문맥상 맞지 않습니다.\n\n(C) Effectively: '효과적으로'라는 부사로, 이 문맥에서는 적절하지 않습니다.\n\n(D) Effect: '영향, 효과'라는 명사로, 이 문맥에서는 적절하지 않습니다.",
    translation:
      "다음 주부터, 뉴욕시의 모든 지하철역이 일시적으로 폐쇄될 것입니다.",
    type: "article",
  },
  {
    id: 23,
    koreanQuestion:
      "우리는 조치를 취하고 있다 설치하기 위해 새로운 결제 단말기를 도시 지하철 시스템 전체에.",
    question:
      "We are taking this _____ to install new payment terminals throughout the city's subway system.",
    choices: {
      A: "measure",
      B: "measurement",
      C: "measuring",
      D: "measures",
    },
    correctAnswer: "A",
    explanation:
      "(A) measure: '조치, 방안'이라는 의미로, 'take a measure'는 '조치를 취하다'라는 표현으로 가장 적절합니다.\n\n(B) measurement: '측정, 치수'라는 의미로, 조치를 취하는 맥락에서는 적절하지 않습니다.\n\n(C) measuring: '측정하는'이라는 현재분사로, 명사가 필요한 이 문맥에서는 적절하지 않습니다.\n\n(D) measures: 복수형 명사로, 단수형인 'this'와 함께 사용할 수 없습니다.",
    translation:
      "우리는 도시 지하철 시스템 전체에 새로운 결제 단말기를 설치하기 위해 이 조치를 취하고 있습니다.",
    type: "article",
  },
  {
    id: 24,
    koreanQuestion:
      "도시 주민들은 (현재) _____  여러 건의 공식 불만을 구식 결제 방식에 대해 그.. 현재 사용되는 중인 도시의 지하철역에서.",
    question:
      "The city residents have _____ several formal complaints against the medieval payment method currently being in use at the city's subway stations.",
    choices: {
      A: "filed",
      B: "filling",
      C: "to file",
      D: "file",
    },
    correctAnswer: "A",
    explanation:
      "(A) filed: '제기하다, 접수하다'라는 의미로, 공식적인 불만이나 항의를 제출할 때 가장 적절한 표현입니다. 'file a complaint'는 '불만을 제기하다'라는 관용적 표현입니다.\n\n(B) filling: '채우는 중'이라는 현재분사로, 현재완료형 'have'와 함께 사용하기에 문법적으로 맞지 않습니다.\n\n(C) to file: '제기하기 위해'라는 부정사로, 현재완료형 'have'와 함께 사용하기에 문법적으로 맞지 않습니다.\n\n(D) file: '제기하다'의 원형으로, 현재완료형 'have'와 함께 사용할 때는 과거분사형이 필요하므로 부적절합니다.",
    translation:
      "도시 주민들은 현재 도시의 지하철역에서 사용 중인 중세적인 결제 방식에 대해 여러 건의 공식 불만을 제기했습니다.",
    type: "article",
  },
  {
    id: 25,
    koreanQuestion:
      "뉴욕 시민들이 설명하듯이, 현재의 결제 방식은 구매할 수 있게 한다 티켓을 지하철역에서만, 그.. 일으키는 긴 줄을 그리고 만드는 많은 통근자들을 스트레스 받게.",
    question:
      "_____ New Yorkers explain, the current payment method allows purchasing tickets only at subway stations, which causes long lines and makes many commuters stressed.",
    choices: {
      A: "As",
      B: "Since",
      C: "While",
      D: "Because",
    },
    correctAnswer: "A",
    explanation:
      "(A) As: '~처럼, ~대로'라는 의미로, 여기서는 '뉴욕 시민들이 설명하는 바와 같이'라는 의미로 가장 적절합니다.\n\n(B) Since: '~이후로, ~때문에'라는 의미로, 이 문맥에서는 시간적 관계나 인과관계를 나타내기에 적절하지 않습니다.\n\n(C) While: '~하는 동안, ~인 반면에'라는 의미로, 대조를 나타내거나 동시성을 표현할 때 사용되며 이 문맥에서는 적절하지 않습니다.\n\n(D) Because: '~때문에'라는 의미로, 원인을 나타내지만 이 문맥에서는 뉴욕 시민들의 설명을 인용하는 방식으로 사용되어 적절하지 않습니다.",
    translation:
      "뉴욕 시민들이 설명하듯이, 현재의 결제 방식은 지하철역에서만 티켓을 구매할 수 있게 하여, 긴 줄을 만들고 많은 통근자들을 스트레스 받게 합니다.",
    type: "article",
  },
  {
    id: 26,
    koreanQuestion:
      "첫 번째 단계 동안, 그.. 걸릴 3주, 새로운 결제 단말기들이 설치될 것입니다.",
    question:
      "_____ the first phase, which will take three weeks, the new payment terminals will be installed.",
    choices: {
      A: "While",
      B: "Since",
      C: "During",
      D: "Despite",
    },
    correctAnswer: "C",
    explanation:
      "(C) During: '~동안에'라는 의미로, 특정 기간 내에 일어나는 일을 표현할 때 가장 적절합니다.\n\n(A) While: '~하는 동안에'라는 의미로, 주로 두 가지 동시에 일어나는 행동을 연결할 때 사용되며, 명사구와 함께 사용하기에는 적절하지 않습니다.\n\n(B) Since: '~이후로, ~때문에'라는 의미로, 시간의 시작점이나 이유를 나타내는 데 사용되며 이 문맥에서는 적절하지 않습니다.\n\n(D) Despite: '~에도 불구하고'라는 의미로, 양보의 의미를 나타내며 이 문맥에서는 적절하지 않습니다.",
    translation:
      "첫 번째 단계 동안, 이는 3주가 걸릴 것이며, 새로운 결제 단말기들이 설치될 것입니다.",
    type: "article",
  },
  {
    id: 27,
    koreanQuestion:
      "두 번째 단계는 시작될 것입니다 ____ 첫 번째 단계 이후에 그리고 포함할 것입니다 작은 구조적 그리고 시설 개선들을.",
    question:
      "The second phase will begin ____ after the first one and will include minor structural and facility improvements.",
    choices: {
      A: "casually",
      B: "immediately",
      C: "rarely",
      D: "doubtfully",
    },
    correctAnswer: "B",
    explanation:
      "(B) immediately: '즉시, 바로'라는 의미로, 첫 번째 단계가 끝난 직후에 두 번째 단계가 시작된다는 의미를 정확히 전달합니다.\n\n(A) casually: '가볍게, 우연히'라는 의미로, 계획된 프로젝트 단계의 시작을 설명하는 데 적절하지 않습니다.\n\n(C) rarely: '드물게, 좀처럼 ~않는'이라는 의미로, 확실히 일어날 계획된 단계를 설명하는 데 적절하지 않습니다.\n\n(D) doubtfully: '의심스럽게'라는 의미로, 확정된 계획을 설명하는 데 적절하지 않습니다.",
    translation:
      "두 번째 단계는 첫 번째 단계 직후에 시작될 것이며 작은 구조적 및 시설 개선을 포함할 것입니다.",
    type: "article",
  },
  {
    id: 28,
    koreanQuestion:
      "______ 정부 통계에 따르면, 실업률은 감소했습니다 2% 지난 분기에.",
    question:
      "______ government statistics, the unemployment rate decreased by 2% last quarter.",
    choices: {
      A: "Despite",
      B: "According to",
      C: "Without",
      D: "Alongside",
    },
    correctAnswer: "B",
    explanation:
      "(B) According to: '~에 따르면'이라는 의미로, 정보의 출처를 나타내는 데 가장 적절합니다.\n\n(A) Despite: '~에도 불구하고'라는 의미로, 양보의 의미를 나타내며 이 문맥에서는 적절하지 않습니다.\n\n(C) Without: '~없이'라는 의미로, 부재나 결여를 나타내며 이 문맥에서는 적절하지 않습니다.\n\n(D) Alongside: '~옆에, ~와 함께'라는 의미로, 물리적 근접이나 협력을 나타내며 이 문맥에서는 적절하지 않습니다.",
    translation: "정부 통계에 따르면, 실업률은 지난 분기에 2% 감소했습니다.",
    type: "article",
  },
  {
    id: 29,
    koreanQuestion:
      "최근 데이터 유출 사건에 비추어, 회사는 발표했습니다 강화된 사이버 보안 조치를.",
    question:
      "______ the recent data breach, the company announced enhanced cybersecurity measures.",
    choices: {
      A: "In light of",
      B: "On behalf of",
      C: "Along with",
      D: "Aside from",
    },
    correctAnswer: "A",
    explanation:
      "(A) In light of: '~에 비추어, ~을 고려하여'라는 의미로, 어떤 상황이나 사건을 고려하여 취해진 조치를 설명할 때 가장 적절합니다.\n\n(B) On behalf of: '~을 대신하여, ~을 대표하여'라는 의미로, 다른 사람이나 단체를 대신하여 행동할 때 사용되며 이 문맥에서는 적절하지 않습니다.\n\n(C) Along with: '~와 함께, ~뿐만 아니라'라는 의미로, 추가적인 요소나 동반자를 나타내며 이 문맥에서는 적절하지 않습니다.\n\n(D) Aside from: '~을 제외하고, ~외에'라는 의미로, 특정 항목을 제외하거나 별도로 언급할 때 사용되며 이 문맥에서는 적절하지 않습니다.",
    translation:
      "최근 데이터 유출 사건에 비추어, 회사는 강화된 사이버 보안 조치를 발표했습니다.",
    type: "article",
  },
  {
    id: 30,
    koreanQuestion:
      "제품 출시행사 동안 내일, CEO는 ___ 할 것이다 회사의 새로운 전기 자동차 프로토타입을.",
    question:
      "During the product launch tomorrow, the CEO will ______ the company's new electric vehicle prototypes.",
    choices: {
      A: "showcase",
      B: "share",
      C: "shred",
      D: "schedule",
    },
    correctAnswer: "A",
    explanation:
      "(A) showcase: '전시하다, 선보이다'라는 의미로, 제품 출시 행사에서 새로운 제품을 공개적으로 보여주는 상황에 가장 적합합니다.\n\n(B) share: '공유하다'라는 의미로, 정보나 자원을 다른 사람과 나누는 것을 의미하지만, 제품 출시 행사의 맥락에서는 'showcase'보다 덜 구체적입니다.\n\n(C) shred: '찢다, 파쇄하다'라는 의미로, 제품을 선보이는 상황과는 완전히 반대되는 의미입니다.\n\n(D) schedule: '일정을 잡다, 예약하다'라는 의미로, 이미 예정된 행사에서 제품을 보여주는 행위를 설명하는 데 적절하지 않습니다.",
    translation:
      "내일 제품 출시 행사에서, CEO는 회사의 새로운 전기 자동차 프로토타입을 선보일 것입니다.",
    type: "article",
  },
];
